import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $tick = _ref.$tick,
      $f7 = _ref.$f7;
  var page_name = 'nvut-tieuchi-popup';
  var pn = ".".concat(page_name);
  var table = 'nvut_baocao';
  var rows,
      calendar,
      ngay = moment().format('YYYY-MM-DD');

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_get',
              table: 'nvut_tieuchi',
              params: {
                order: 'id',
                where: 'deleted_at IS NULL'
              }
            });

          case 2:
            rs = _context.sent;
            rows = rs.rows;
            $update(function () {
              checkedTieuchi();
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var checkedTieuchi = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var loading, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loading = $f7.dialog.preloader('Đợi chút...');
              _context2.next = 3;
              return Base.call({
                method: '_get',
                table: table,
                params: {
                  where: 'id_emp=:id_emp AND ngay=:ngay',
                  where_data: {
                    id_emp: props.emp.id,
                    ngay: ngay
                  }
                }
              });

            case 3:
              rs = _context2.sent;
              loading.close();
              $(pn + ' input[type=checkbox]').prop('checked', false);

              if (!(rs.rows.length === 0)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              $(pn + ' input[type=checkbox]').each(function () {
                var _this = this;

                var value = parseInt($(this).val());
                $(this).prop('checked', false);
                rs.rows.forEach(function (row) {
                  if (row.id_tieuchi === value) {
                    $(_this).prop('checked', true);
                    return;
                  }
                });
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function checkedTieuchi() {
      return _ref3.apply(this, arguments);
    };
  }();

  var dateChanged = function dateChanged(e) {
    ngay = moment($(e.target).val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
    checkedTieuchi();
  };

  var tieuchiChanged = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var id, tieuchi, checked, rs, _rs;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              id = parseInt($(e.target).data('id'));
              tieuchi = rows.find(function (row) {
                return row.id === id;
              });
              checked = $(e.target).prop('checked');

              if (!checked) {
                _context3.next = 9;
                break;
              }

              _context3.next = 6;
              return Base.call({
                method: '_post',
                table: table,
                params: {
                  id_emp: props.emp.id,
                  id_tieuchi: tieuchi.id,
                  ngay: ngay,
                  so_tien: tieuchi.so_tien
                }
              });

            case 6:
              rs = _context3.sent;
              _context3.next = 12;
              break;

            case 9:
              _context3.next = 11;
              return Base.call({
                method: '_hardDeleteWhere',
                table: table,
                params: {
                  where: 'id_emp=:id_emp AND id_tieuchi=:id_tieuchi AND ngay=:ngay',
                  where_data: {
                    id_emp: props.emp.id,
                    id_tieuchi: tieuchi.id,
                    ngay: ngay
                  }
                }
              });

            case 11:
              _rs = _context3.sent;

            case 12:
              $f7.toast.create({
                text: 'Lưu lại thành công',
                closeTimeout: 1500,
                position: 'top'
              }).open();

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function tieuchiChanged(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  $tick(function () {
    calendar = $f7.calendar.create({
      inputEl: $(pn + ' .date-selected'),
      dateFormat: 'd/m/yyyy',
      closeOnSelect: true
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup ${page_name}" data-name="${page_name}">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title">Nhắc nhở ${props.emp.name}</div>
        <div class="right">
          <a href="#" class="link popup-close" data-popup=".${page_name}"><i class="icon f7-icons">multiply</i></a>
        </div>
      </div>
    </div>
    <div class="page-content no-padding">
      <div class="list inline-labels no-margin">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Ngày</div>
              <div class="item-input-wrap"><input type="text" value="${moment().format(Base.dateFormat)}" class="date-selected" readonly name="date-selected" @change="${dateChanged}" /></div>
            </div>
          </li>
        </ul>
      </div>
      
      <div class="block-title margin-half">Nhân viên đã KHÔNG:</div>

      <div class="list">
        <ul>
          ${rows && rows.map(row=>$h`
            <li key="${row.id}">
              <label class="item-checkbox item-content">
                <input type="checkbox" value="${row.id}" data-id="${row.id}" @change="${tieuchiChanged}" />
                <i class="icon icon-checkbox"></i>
                <div class="item-inner">
                  <div class="item-title">${row.name}</div>
                </div>
              </label>
            </li>
          `)}
        </ul>
      </div>
    </div>
  </div>
`
    }
    ;
});